// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/style.css'
import _ from 'lodash'
import moment from 'moment'
import exportCSV from './utils/exportcsv';
import Highcharts from 'highcharts'
import { GetQueryString, GetRequest } from '@/utils/util'
import { Button, Modal, Table, Input, Checkbox, Popover, Popconfirm, ConfigProvider, Card, Form, Icon, Divider, Collapse, Slider } from 'ant-design-vue';
import nLogin from 'n-vue/lib/login'
import nDatePicker from 'n-vue/lib/datePicker'
window.$Vue = Vue

Vue.use(nLogin.nLogin);
Vue.use(nDatePicker);
Vue.use(nMap);

Vue.prototype.$logout = nLogin.logout
Vue.use(Button);
Vue.use(Modal);
Vue.use(Table);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Popover);
Vue.use(Popconfirm);
Vue.use(ConfigProvider);
Vue.use(Card);
Vue.use(Form);
Vue.use(Icon);
Vue.use(Divider);
Vue.use(Collapse);
Vue.use(Slider);


exportCSV(Highcharts)
Vue.use(ElementUI);
Vue.use(Highcharts);


var app_id = '14'//10015
var profile_id = GetRequest('profile_id')
var model = GetRequest('model')
var pollution_track = GetRequest('pollution_track')
var token = GetRequest('token')
var username = GetRequest('username')
console.log(username, token)
if (token && username) {
  sessionStorage.setItem("token_0", token)
  sessionStorage.setItem("10015_yc_token", token)
  sessionStorage.setItem("userName", username)
}
if (!model){
	model = 0
}
store.commit('setModel', model)
store.commit('setPollutionTrack', pollution_track)
var $profile_id = 1
if (profile_id){
	$profile_id = profile_id
}
Vue.prototype.$is_dock_env = process.env.DOCK_ENV
Vue.prototype.$profile_id = $profile_id
Vue.prototype.$_ = _
Vue.prototype.$moment = moment
Vue.prototype.$model = model
Vue.prototype.$app_id = app_id
Vue.prototype.$img_base_path = 'https://jnwzhuabei2.oss-cn-beijing.aliyuncs.com/wind_rose_image/'
Vue.config.productionTip = false
store.commit("setCommon", {
	model: model,
	profile_id: $profile_id
})

// 智慧平台使用此id
var token = sessionStorage.getItem('10015_yc_token')
if (token) {
  store.commit("setToken", token)
}
console.log(process.env.NODE_ENV)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js